import React, { useState, useEffect } from "react";
import { Users, Wallet, MinusCircle, Banknote } from "lucide-react";
import { getPayrollSummaryApi } from "../../../app/api";

const PayrollKPIs = ({ fromMonth, toMonth, refreshTrigger }) => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        setLoading(true);
        const res = await getPayrollSummaryApi(fromMonth, toMonth);
        if (res.success) {
          setStats(res.data);
        }
      } catch (error) {
        console.error("Error fetching payroll stats:", error);
      } finally {
        setLoading(false);
      }
    };

    if (fromMonth) {
      fetchStats();
    }
  }, [fromMonth, toMonth, refreshTrigger]);

  const kpis = stats ? [
    {
      label: "Total Employees",
      value: stats.total_employees,
      change: "Active this month",
      icon: Users,
      color: "bg-[#D9D7FF]",
      iconColor: "text-[#5A51D6]",
      textColor: "text-gray-900",
      changeColor: "text-purple-600"
    },
    {
      label: "Gross Payroll",
      value: `₹${Number(stats.gross_payroll).toLocaleString()}`,
      change: "Total payout",
      icon: Wallet,
      color: "bg-[#E0FBEA]",
      iconColor: "text-[#22C55E]",
      textColor: "text-gray-900",
      changeColor: "text-green-600"
    },
    {
      label: "Total Deductions",
      value: `₹${Number(stats.total_deductions).toLocaleString()}`,
      change: "Taxes & others",
      icon: MinusCircle,
      color: "bg-[#FFE4E1]",
      iconColor: "text-[#EF4444]",
      textColor: "text-gray-900",
      changeColor: "text-red-600"
    },
    {
      label: "Net Payable",
      value: `₹${Number(stats.net_payable).toLocaleString()}`,
      change: "Final disbursement",
      icon: Banknote,
      color: "bg-[#E0F2FE]",
      iconColor: "text-[#0EA5E9]",
      textColor: "text-gray-900",
      changeColor: "text-blue-600"
    },
  ] : [];

  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 animate-pulse">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="h-32 bg-white/5 rounded-2xl border border-white/10"></div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
      {kpis.map((kpi, i) => (
        <div key={i} className={`${kpi.color} border border-white/10 p-5 rounded-2xl space-y-3 shadow-lg transform hover:scale-[1.02] transition-all duration-300`}>
          <div className="flex items-center justify-between">
            <div className="bg-white/40 p-3 rounded-xl">
              <kpi.icon className={kpi.iconColor} size={24} />
            </div>
          </div>
          <div>
            <p className={`${kpi.textColor} opacity-60 text-xs font-bold uppercase tracking-wider`}>{kpi.label}</p>
            <h3 className={`text-2xl font-black mt-1 ${kpi.textColor}`}>{kpi.value}</h3>
            <p className={`text-[10px] mt-1 font-bold ${kpi.changeColor}`}>
              {kpi.change}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PayrollKPIs;
